<template>
  <div v-if="showGangSheetBuilderFeature" class="gang-sheet-builder-builder-container">
    <GangSheetBuilder v-if="showGangSheetBuilder" />
    <span class="gang-sheet-builder-builder-container__new-icon">🔥 NEW!</span>
    <button
      class="gang-sheet-builder-builder-container__button"
      type="button"
      @click="handleGangSheetBuilder"
      @click.stop
    >
      Build a Gang Sheet
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import GangSheetBuilder from "./GangSheetBuilder.vue";
import { useDtfStore } from "./store";

export default {
  name: "GangSheetBuilderContainer",
  components: {
    GangSheetBuilder
  },
  computed: {
    ...mapState(useDtfStore, ["showGangSheetBuilderFeature", "showGangSheetBuilder"])
  },
  methods: {
    ...mapActions(useDtfStore, ["setShowGangSheetBuilder"]),
    handleGangSheetBuilder() {
      this.setShowGangSheetBuilder(true);
      submitDtfEvent("gangsheet_builder_opened", {});
    }
  }
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.gang-sheet-builder-builder-container {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  min-height: 40px;

  &__button {
    height: 40px;
    width: 190px;
    padding: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: $primary-light;
    color: $white;
    font-weight: 700;
    border: none;
  }

  &__new-icon {
    position: absolute;
    color: $white;
    font-family: Poppins;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: 12px;
    padding: 6px 4px 4px 4px;
    background-color: $green-emerald-small-light;
    border-radius: 124px;
    left: -20px;
    top: -10px;
  }
}
</style>
